export interface ISectionData
{
    title: string;
    link: string;
}

export class Section
{
    constructor(
        public data: ISectionData,
        public content: string[]
    ) {}
}